import { ReactNode, useState, createContext } from "react";
import { Theme } from "@mui/material";
import theme from "app/theme";

type IThemeSwitchContext = {
  theme: Theme;
  updateTheme?: (primaryColor: string, secondaryColor: string, primaryLight?: string) => void;
};

export const themeSwitchContext = createContext<IThemeSwitchContext>({
  theme: theme,
  updateTheme: () => {},
});

export function ThemeSwitchProvider({ children }: { children: ReactNode }) {
  const [themeState, setThemeState] = useState(theme);

  const updateThemeFn = (primary: string, secondary: string, primaryLight?: string, primaryDark?: string) => {
    setThemeState((prev) => ({
      ...prev,
      palette: {
        ...prev.palette,
        primary: {
          ...prev.palette.primary,
          main: primary,
          light: primaryLight || "",
          dark: primaryDark || "",
        },
        secondary: {
          ...prev.palette.secondary,
          main: secondary,
        },
      },
    }));
  };

  return (
    <themeSwitchContext.Provider
      value={{
        theme: themeState,
        updateTheme: updateThemeFn,
      }}
    >
      {children}
    </themeSwitchContext.Provider>
  );
}
